import { useTranslation } from 'react-i18next';

import { Button } from '@unified-checkout/design-system';

import type { IFooterProps } from '@app/dashboard/types/innerLayout/profile_details/footer';

import styles from './Footer.module.scss';

const Footer = ({
  isLoading,
  shouldDisabledPrimary,
  shouldDisabledSecondary,
  primaryBtnText,
  handleCancelChanges,
  handlePrimaryAction,
}: IFooterProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles['footer']}>
      <Button
        text={t(
          'innerLayout.profileDetailsPage.changePasswordPage.actions.cancel'
        )}
        variant="outlined"
        color="secondary"
        size="md"
        disabled={shouldDisabledSecondary || isLoading}
        onClickHandler={handleCancelChanges}
      />
      <Button
        variant="contained"
        color="primary"
        size="md"
        loading={isLoading}
        disabled={shouldDisabledPrimary || isLoading}
        text={primaryBtnText}
        onClickHandler={handlePrimaryAction}
      />
    </div>
  );
};

export default Footer;
